/**
 * React bindings — shared by @ringg/web (React DOM) and @ringg/react-native.
 *
 * Every hook is a useSyncExternalStore call over a core store; there is no
 * behavior here and there must never be. A fix to typing timing, message
 * ordering, or session lifecycle lands in the stores once and both platforms
 * pick it up.
 *
 * Imported via the "@ringg/core/react" subpath so non-React consumers of
 * core never touch the react dependency (it's an optional peer).
 */
import { useSyncExternalStore } from "react";
export function useStoreSnapshot(store) {
    return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
export const useRinggMessages = (controller) => useStoreSnapshot(controller.messages);
export const useRinggTyping = (controller) => useStoreSnapshot(controller.typing);
export const useRinggSession = (controller) => useStoreSnapshot(controller.session);
export const useRinggShell = (controller) => useStoreSnapshot(controller.shell);
export const useRinggComponents = (controller) => useStoreSnapshot(controller.components);
export const useRinggSlashCommands = (controller) => useStoreSnapshot(controller.slashCommands);
